module.exports = __webpack_public_path__ + "static/media/idlepage-companies.1f448b85.svg";